import { render } from "./ReqManageMain.vue?vue&type=template&id=5dc0fc62&scoped=true"
import script from "./ReqManageMain.vue?vue&type=script&lang=js"
export * from "./ReqManageMain.vue?vue&type=script&lang=js"

import "./ReqManageMain.vue?vue&type=style&index=0&id=5dc0fc62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc0fc62"]])

export default __exports__